import jQuery from 'jquery';
let $ = jQuery;

/**
* class HSN.ImageSwapper
*
* Provides a very lightweight functionality for swapping the anchor/image of a main image area with the values coming from a set of alternate anchors/images.
**/
HSN.ImageSwapper = function (config) {
    /**
        * new HSN.ImageSwapper(config)
        * - config (Object): A configuration object for the [[HSN.ImageSwapper]
        *   consisting of the following keys:
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the container of the alternate triggers.
        *   - destinationAnchor (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to the anchor tag surrounding the main image.
        *   - destinationImage (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to the main image tag.
        *   - triggerSelector (String): A CSS selector used find descendents of the container to trigger image swaps.
        **/
    var scope = this;

    this._container = $(config.container);
    this._destinationAnchor = $(config.destinationAnchor);
    this._destinationImage = $(config.destinationImage);
    this._triggerSelector = config.triggerSelector;
    this._useHover = config.useHover;
    this._useData = config.useData;
    this._followTriggerHref = config.followTriggerHref;

    var selectedImg = this._container.find(this._triggerSelector).filter('.selected').get(0);

    this._container.on('mouseenter', this._triggerSelector, function () {
        $(this).addClass('hover');

        if (scope._useHover) {
            scope.SynchronizeSelectedTriggerState(this);
        }
    });

    this._container.on('mouseleave', this._triggerSelector, function () {
        $(this).removeClass('hover');

        if (scope._useHover) {
            if (selectedImg) {
                scope.SynchronizeSelectedTriggerState(selectedImg);
        }
        }
    });

    this._container.on('click', this._triggerSelector, function (e) {
        e.preventDefault();

        if (!scope._useHover) {
            scope.SynchronizeSelectedTriggerState(this);
        }
    });
};

HSN.ImageSwapper.prototype = {
    /**
    * HSN.ImageSwapper#ActivateTrigger(trigger, className) -> void
    * - trigger (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve one of the triggers.
    * - className (String): The CSS class name to add to the trigger when activated.
    *
    * Modifies the trigger as necessary to support the activated state of the trigger and adds the given class.
    **/
    ActivateTrigger: function (trigger, className) {
        var $trigger = $(trigger);

        var $triggerOverlay = $trigger.find('.overlay');
        if (!$triggerOverlay.length) {
            $triggerOverlay = $('<div class="overlay"></div>');
            $trigger.append($triggerOverlay);
            if (this._followTriggerHref) {
                $triggerOverlay.click(function () {
                    window.location = $trigger.attr('href');
                });
            }
        }

        $trigger.addClass(className);
    },

    /**
    * HSN.ImageSwapper#DeactivateTrigger(trigger) -> void
    * - trigger (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve one of the triggers.
    *
    * Restores the state of the given trigger to a deactivated state by removing the given class name.
    **/
    DeactivateTrigger: function (trigger, className) {
        $(trigger).removeClass(className);
        $(trigger).find('.overlay').remove();
    },

    /**
    * HSN.ImageSwapper#SynchronizeSelectedTriggerState(trigger) -> void
    * - trigger (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the trigger to be marked selected.
    *
    * Sets the given trigger into the selected state while removing the selected state from any other triggers.
    **/
    SynchronizeSelectedTriggerState: function (trigger) {
        if (!trigger) {
            return;
        }

        var $trigger = $(trigger);

        var triggerImageUrl = this._useData ? $trigger.data('image') : $trigger.attr('href');
        var triggerZoomImageUrls = $trigger.data('zoom');

        if (triggerImageUrl) {
            this._destinationImage.attr('src', triggerImageUrl);
        }

        if (this._destinationAnchor) {
            if (triggerImageUrl) {
                this._destinationAnchor.attr('href', triggerImageUrl);
            }
            if (triggerZoomImageUrls) {
                this._destinationAnchor.data('zoom', triggerZoomImageUrls);
        }
        }

        var currentlyActiveTriggers = this._container.find(this._triggerSelector).filter('.active');
        if (currentlyActiveTriggers.length) {
            this.DeactivateTrigger(currentlyActiveTriggers, 'active');
        }

        this.ActivateTrigger(trigger, 'active');
    },

    SetPlusSizeMode: function (enabled) {
        this._plusSizeMode = enabled;
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/ImageSwapper.js